/// <reference types="vite/client" />
/**
 * Ссылка на папку Progresses на Google Drive и путь внутри неё.
 * Структуру папок (Организация / Подрядчик / Договор) вы создаёте вручную.
 * В комментарий сохраняются: ссылка на корень + текстовый путь (без API).
 */

/** Корневая папка Progresses — одна ссылка для всех, без API */
const ROOT_FOLDER_URL =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_DRIVE_PROGRESSES_FOLDER_URL) ||
  'https://drive.google.com/drive/folders/1S7ipE3z4VT4JyZR5qG_xGY4bQwM7yjy0?usp=drive_link';

/** Префикс строки в комментарии со ссылкой на папку Drive */
export const DRIVE_LINE_PREFIX = 'Drive: ';
/** Префикс строки с путём внутри папки (для подсказки, куда зайти) */
export const DRIVE_PATH_PREFIX = 'Drive path: ';

/**
 * Возвращает ссылку на корневую папку Progresses (для кнопки «Upload photos»).
 */
export function getProgressesFolderLink(): string {
  return ROOT_FOLDER_URL;
}

/**
 * Собирает текстовый путь: Организация / Подрядчик / Договор.
 * Символы / и \ в названиях заменяются на пробел, чтобы не путать с разделителем.
 */
export function buildDrivePath(params: {
  organizationName: string | undefined;
  contractorName: string | undefined;
  contractName: string | undefined;
}): string {
  const clean = (s: string | undefined) =>
    (s ?? '')
      .trim()
      .replace(/[/\\]/g, ' ')
      .trim() || '—';
  const org = clean(params.organizationName);
  const contractor = clean(params.contractorName);
  const contract = clean(params.contractName);
  return `${org} / ${contractor} / ${contract}`;
}

/**
 * Извлекает из комментария накладной ссылку на папку (строка вида "Drive: https://...").
 */
export function getDriveLinkFromComment(comment: string | undefined): string | null {
  if (!comment) return null;
  const line = comment.split('\n').find((l) => l.startsWith(DRIVE_LINE_PREFIX));
  if (!line) return null;
  const link = line.slice(DRIVE_LINE_PREFIX.length).trim();
  return link && link.startsWith('http') ? link : null;
}
